import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import CardImageFooterA from 'components/CardImageFooter/CardImageFooterA';
import { isEmpty } from 'lodash';
import classes from './CardImageD.module.scss';

const CardImageD = (props) => {
  const {
    imageURI,
    imageLink = {},
    heading,
    contentMarkup,
    buttons,
    links,
    listType,
  } = props;

  const footerChildren = listType === 'Links' ? links : buttons;

  const imageContainer = () => {
    const image = <div className={classes.image} style={{ backgroundImage: `url(${imageURI})` }} />;
    if (!isEmpty(imageLink)) {
      return (
        <Link href={imageLink.href} target={imageLink.target}>
          {image}
        </Link>
      );
    }

    return image;
  };

  return (
    <div className={classes.container}>
      {imageURI && imageContainer()}
      {(heading || contentMarkup || buttons.length > 0 || links.length > 0) &&
        <div className={classes.content}>
          {heading &&
            <h3
              className={classes.title}
              dangerouslySetInnerHTML={{ __html: heading }}
            />}
          {contentMarkup &&
            <div
              className={classes.description}
              dangerouslySetInnerHTML={{ __html: contentMarkup }}
            />}
          <CardImageFooterA
            classes={classes}
            footerChildren={footerChildren}
            containerKey='CardImageD-footerChildren'
          />
        </div>}
    </div>
  );
};

CardImageD.propTypes = {
  /**
   * Heading on the card
  */
  heading: PropTypes.string,
  /**
   * Image URL
  */
  imageURI: PropTypes.string,
  /**
   * Content of the card
  */
  contentMarkup: PropTypes.string,
  /**
   * Image Link Object
  */
  imageLink: PropTypes.shape({
    title: PropTypes.string,
    href: PropTypes.string,
    target: PropTypes.string,
    imageUrl: PropTypes.string,
    altText: PropTypes.string,
  }),
  /**
   * List of buttons<br>
   * Only used when `listType` = `Buttons`
  */
  buttons: PropTypes.array,
  /**
   * List of links<br>
   * Only used when `listType` = `Links`
  */
  links: PropTypes.array,
  /**
    * Type of list<br>
    * Options: `Buttons` `Links`
  */
  listType: PropTypes.string,
};

export default CardImageD;
